import { ConfigProvider, Empty, Spin } from "antd";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { get } from "../../../services/ApiRouting";

export default function Comopnay({ links, nav }) {
  const [navigation, setNavigation] = useState([
    { name: "Resort", link: "resort" },
  ]);

  const [vendors, setVendors] = useState([]);
  const [venues, setVenues] = useState([]);
  const [cast, setCast] = useState([]);
  const [event, setEvent] = useState([]);

  const getVenues = async () => {
    try {
      const resp = await get("subcategories?category_id=1");
      setVenues(resp?.data);
      return resp;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const getVendors = async () => {  
    try {
      const resp = await get("categories");
      setVendors(resp?.data);
      return resp;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const getCommunities = async (type) => {
    try {
      const resp = await get("communities?type=" + type);
      if (type === 1) {
        setCast(resp?.data);
      }

      if (type === 0) {
        setEvent(resp?.data);
      }
      return resp;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    (async () => {
      switch (nav) {
        case "Venues":
          if (venues?.length > 0) {
            setNavigation(
              venues?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?category=venues" + "&subcategory=" + val.slug,
              }))
            );
          } else {
            const data = await getVenues();
            setNavigation(
              data?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?category=venues" + "&subcategory=" + val.slug,
              }))
            );
          }
          break;
        case "Vendors":
          if (vendors?.length > 0) {
            setNavigation(
              vendors?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?category=" + val?.slug,
              }))
            );
          } else {
            const data = await getVendors();
            setNavigation(
              data?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?category=" + val?.slug,
              }))
            );
          }
          break;
        case "Find by Cast":
          if (cast?.length > 0) {
            setNavigation(
              cast?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?cast=" + val?.slug,
              }))
            );
          } else {
            const data = await getCommunities("cast");
            setNavigation(
              data?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?cast=" + val?.slug,
              }))
            );
          }
          break;
        case "Plan by Events":
          if (event?.length > 0) {
            setNavigation(
              event?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?event=" + val?.slug,
              }))
            );
          } else {
            const data = await getCommunities("event");
            setNavigation(
              data?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?event=" + val?.slug,
              }))
            );
          }
          break;
        default:
          setNavigation([]);
          break;
      }
    })();
  }, [nav]);

  return (
    <div className="container dropdown-style">
      {navigation.length > 0 ? (
        <ul>
          <div className="row">
            {navigation.map((val, index) => (
              <div className="col-md-4" key={index}>
                <li>
                  <NavLink to={val?.link}>{val?.name}</NavLink>
                </li>
              </div>
            ))}
          </div>
        </ul>
      ) : (
        <Empty
          image="https://i.pinimg.com/236x/56/46/be/5646be2b200df93b547784b2903c3a2e.jpg"
          description={
            <div>
              <h5>No Data Found</h5>
              <p>We are finding list of data please wait...</p>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "#800000",
                  },
                }}
              >
                <Spin indicator={<LoadingOutlined spin />} spinning></Spin>
              </ConfigProvider>
            </div>
          }
        />
      )}
    </div>
  );
}
